export default {
    // Navigation menu
    getDrawer(state) { return state.drawer },
    getOpenDriver(state) { return state.openDriver },
    // General Application Data
    getIsLoggedIn(state) { return state.isLoggedIn },
    getPrevRoute(state) { return state.prevRoute },
    // getLanguage(state) {  }, // TODO
    // getLanguageMessages missing? i18n.messages?

    // User-Object
    getUser(state) { return state.user },
    getUserCustomerCompany(state) { return state.user.customerCompany },
    getUserCustomerNumber(state) { return state.user.customerNumber },
    getUserLanguage(state) { return state.user.language },
    getUserUsername(state) { return state.user.username },
    getSelectedCurrency(state) { 
        if(state.isLoggedIn) state.selectedCurrency = JSON.parse(localStorage.getItem('userData'))['user']['currency']
        return state.selectedCurrency
    }, 
    getHomeSociety(state) { return state.user.homeSociety },
    getHomeSocietyCode(state) { return state.user.homeSocietyCode },
    getCompanyCountry(state) { return state.user.companyCountry },
    getDigitalDistributionIsBooked(state) { return state.user.digitalDistribution },
    getUserModules(state) { return state.user.modules },

    // getUserToken() { return JSON.parse(localStorage.getItem('userData')).jwt }, 
    getUserToken: state => () => { return JSON.parse(localStorage.getItem('userData')).jwt },
    
    // Paging
    getTotalRecords(state) { return state.totalRecords },
    getTotalListed(state) { return state.totalListed },
    getCurrentPage(state) { return state.currentPage },
    getItemsPerPage(state) { return state.itemsPerPage },
    getNumberOfPages(state) { return state.numberOfPages },

    // Searchdialog "paging"
    getTotalRecordsSearchDialog(state) { return state.totalRecordsSearchDialog },
    getTotalListedSearchDialog(state) { return state.totalListedSearchDialog },

    // Publishing & Label Companies (options & current selected)  
    getPublishingCompanies(state) { return state.publishingCompanies },
    getLabelCompanies(state) { return state.labelCompanies },
    getSelectedOverAllCompany(state) { return state.selectedOverAllCompany },
    getSelectedPublishingCompanyId(state) { return state.selectedPublishingCompanyId } ,
    getSelectedLabelCompanyId(state) { return state.selectedLabelCompanyId },   

    // Dropdown options
    getCountries(state) { 
        // state.countries = JSON.parse(localStorage.getItem('userData'))['countries'] 
        return state.countries
    },
    getPublishingContractsTypes(state) { return state.publishingContractsTypes },
    
    getCountriesDE(state) { return state.countries.de },
    getCountriesEN(state) { return state.countries.en },

    getAzTypes(state) { 
        state.azTypes = JSON.parse(localStorage.getItem('userData'))['azTypes']
        return state.azTypes 
    },
    getAzTypesDE(state) { return state.azTypes.de },
    getAzTypesEN(state) { return state.azTypes.en },
    getAzTypesJA(state) { return state.azTypes.ja },
    getAzTypesKO(state) { return state.azTypes.ko },

    getApiConnections(state){
        state.apiConnections = JSON.parse(localStorage.getItem('userData'))['apiConnections']
        return state.apiConnections
    },

    getInterests(state) { return state.interests },
    
    getDealflow(state) { 
        state.dealflow = JSON.parse(localStorage.getItem('userData'))['dealflow']
        return state.dealflow 
    },
    getDealflowDE(state) { return state.dealflow.de },
    getDealflowEN(state) { return state.dealflow.en },

    getVisibility(state) { 
        state.visibility = JSON.parse(localStorage.getItem('userData'))['visibility']
        return state.visibility 
    },
    getVisibilityDE(state) { return state.visibility.de },
    getVisibilityEN(state) { return state.visibility.en },

    getGeneralLanguages(state) { 
        state.generalLanguages = JSON.parse(localStorage.getItem('userData'))['generalLanguageOptions']
        return state.generalLanguages 
    },

    // getContractsApplyTo(state) { 
    //     state.contractsApplyTo = JSON.parse(localStorage.getItem('userData'))['contractApplyTo']
    //     return state.contractsApplyTo 
    // },
    getContractsRights(state) {  
        state.contractsRights = JSON.parse(localStorage.getItem('userData'))['contractRights']
        return state.contractsRights 
    },
    getAccountCredentialsType(state) { 
        state.accountCredentialsType = JSON.parse(localStorage.getItem('userData'))['credentialsType']
        return state.accountCredentialsType 
    },
    getUserInformation(state) { 
        state.userInformation = JSON.parse(localStorage.getItem('userData'))['user']
        return state.userInformation 
    }, 
    
    getGenres(state) { return state.genres},
    getGenresDE(state) { return state.genres.de },
    getGenresEN(state) { return state.genres.en },
    getGenresJA(state) { return state.genres.en },  
    getGenresKO(state) { return state.genres.en },  

    getLanguages(state) { return state.languages},
    getLanguagesDE(state) { return state.languages.de },
    getLanguagesEN(state) { return state.languages.en },

    getPublishingTypeOfRights(state) { return state.publishingTypeOfRights },
    getPublishingTypeOfRightsGema(state) { return state.publishingTypeOfRights.gema },
    getPublishingTypeOfRightsSvd(state) { return state.publishingTypeOfRights.svd },

    getLabelStatisticsInRows(state) { return state.labelStatisticsInRows },
    getLabelStatisticsInRowsAzTypes(state) { return state.labelStatisticsInRows.azTypes },
    getLabelStatisticsInRowsDistributors(state) { return state.labelStatisticsInRows.distributors },
    getLabelStatisticsInRowsProduct(state) { return state.labelStatisticsInRows.product },

    getLicensors(state) { return state.licensors},
    getSocieties(state) { return state.societies },
    getWorkStyles(state) { return state.workStyles },

    getReleaseGemaMediaTypes( state ) { return state.releaseGemaMediaTypes },
    getReleaseMediaTypes( state ) { 
        state.releaseMediaTypes = JSON.parse(localStorage.getItem('userData'))['releaseMediaTypes']
        return state.releaseMediaTypes 
    },

    getInstrumentations(state) { return state.instrumentations },

    // General page data for lists
    getIsLoading(state) { return state.isLoading },
    getNoDataText(state) { return state.noDataText },

    // Dialogs , Snackbars, Alerts
    getSnackbar(state) { return state.snackbar },
    getSelectionRequieredAlert(state) { return state.selectionRequieredAlert },
    getSelectionRequiredText(state) { return state.selectionRequiredText },
    getShowSelectionRequiredDialog(state) { return state.showSelectionRequiredDialog },
    getShowPeriodRequiredDialog(state) { return state.showPeriodRequiredDialog },
    getShowDeletionDialog(state) { return state.showDeletionDialog },
    getDeletionDialogContext(state) { return state.deletionDialogContext },
    getShowMoveContractsDialog(state) { return state.showMoveContractsDialog },
    getConfirmationDialog(state) { return state.confirmationDialog },
    // getShowDeletionDialogProlists(state) { return state.showDeletionDialogProlists },
    // getShowDeletionDialogMyMapping: (state) => { return state.showDeletionDialogMyMapping },
    getShowGemaWorksCheckDialog(state) { return state.showGemaWorksCheckDialog},
    getShowSearchDialog(state) { return state.showSearchDialog },
    getShowConnectArtistDialog(state) { return state.showConnectArtistDialog },
    getShowStatementPreviewDialog(state) { return state.showStatementPreviewDialog },
    // Persons Dialog
    getPersonsPanelEntry(state) { return state.personsPanelEntry },
    getSelectedPersonsPanelEntry(state) { return state.selectedPersonsPanelEntry },
    getPersonsPanelEntryEditingDialogDetails(state) { return state.personsPanelEntryEditingDialogDetails },
    getDefaultPersonsPanelEntry(state) { return state.defaultPersonsPanelEntry },
    getPersonsPanelEntryPersonOptions(state) { return state.personsPanelEntryPersonOptions },
    getPersonsPanelEntryDetailsPerson(state) { return state.selectedPersonPersonsPanelDialog },
    getPersonsPanelEntryDetailsMobil(state) { return state.personsPanelEntryEditingDialogDetails.cellphone },
    getPersonsPanelEntryDetailsEmail(state) { return state.personsPanelEntryEditingDialogDetails.email },
    getPersonsPanelEntryDetailsRole(state) { return state.personsPanelEntryEditingDialogDetails.role },
    getPersonsPanelEntryDetailsInheritFromGroup(state) { return state.personsPanelEntryEditingDialogDetails.inheritFromGroup },
    getPersonsPanelEntryDetailsId(state) { return state.personsPanelEntryEditingDialogDetails.id },
    getPersonsPanelEntryDetailsFirstName(state) { return state.personsPanelEntryEditingDialogDetails.firstName },
    getPersonsPanelEntryDetailsLastName(state) { return state.personsPanelEntryEditingDialogDetails.lastName },
    getPersonsPanelEntryDetailsKeyName(state) { return state.personsPanelEntryEditingDialogDetails.gemaName },

    // Error Dialog
    getShowErrorDialog(state) { return state.showErrorDialog },
    getErrorMessageCode(state) { return state.errorMessageCode },
    getErrorDialogCsvLink(state) { return state.errorDialogCsvLink },
    getErrorDialogMessage(state) { return state.errorDialogMessage },

    // File Import Dialog
    getSelectedFileImportOption(state) { return state.selectedFileImportOption },
    getSelectedFileImport(state) { return state.selectedFileImport },
    getShowImageUploadDialog(state) { return state.showImageUploadDialog},
    getShowMediaFileUploadDialog(state) { return state.showMediaFileUploadDialog},
    getSelectedFileUploadOption(state) { return state.selectedFileUploadOption },
    getShowFileImportDialog(state) { return state.showFileImportDialog },
    getImportDialogText(state) { return state.importDialogText },
    getUploadPictureDialogText(state) { return state.uploadPictureDialogText },
    getSelectedPeriodValuesImportDialog(state){ return state.selectedPeriodValuesImportDialog },
    getSelectedPeriodNumberImportDialog(state) { return state.selectedPeriodValuesImportDialog.num },
    getSelectedPeriodTimeUnitImportDialog(state) { return state.selectedPeriodValuesImportDialog.period },
    getSelectedPeriodYearImportDialog(state) { return state.selectedPeriodValuesImportDialog.year },
    getSelectedImportDialogCheckboxes(state) { return state.selectedImportDialogCheckboxes },

    //Report options dropdown
    getSelectedFileReport(state) { return state.selectedFileReport },

    // Run Error List Dialog
    getShowRunErrorListDialog(state) { return state.showRunErrorListDialog },
    getRunErrorListDialogText(state) { return state.runErrorListDialogText },
    getRunErrorListDialogProgressValue(state) { return state.runErrorListDialogProgressValue },
    getRunErrorListDialogPolling(state) { return state.runErrorListDialogPolling },

    // Inline Editing Dialog (Listpage)
    getShowInlineEditingDialog(state) { return state.showInlineEditingDialog },

    // Regions Dialog
    getShowRegionDialog(state) { return state.showRegionDialog },
    getRegionDialogIncludeOptions(state) { return state.regionDialogIncludeOptions },
    getRegionDialogExcludeOptions(state) { return state.regionDialogExcludeOptions },
    getRegionDialogDetailsInclude(state) { return state.regionDialogDetailsInclude },
    getRegionDialogDetailsExclude(state) { return state.regionDialogDetailsExclude },

    // Editing Dialog
    getShowEditingDialog(state) { return state.showEditingDialog },
    getEditingDialogHeadline(state) { return state.editingDialogHeadline },

    // Manage Tags Dialog
    getShowManageTagsDialog(state) { return state.showManageTagsDialog },
    getAddTag(state) { return state.addTag },
    getRemoveTag(state) { return state.removeTag },
    
    // Manage Sync Data Dialog
    getShowSyncDataDialog(state) { return state.showSyncDataDialog },
    
    // Digital Platforms
    getDigitalPlatforms(state) { return state.digitalPlatforms },

    // File Bulk Uploader
    getSelectedFileBulkImportUploader(state) { return state.selectedFileBulkImportUploader },
    getSelectedFileBulkImport(state) { return state.selectedFileBulkImport },
    getSelectedFileRecordsBulkImport(state) { return state.selectedFileRecordsBulkImport },
    getSelectedFileReportDataBulkImport(state) { return state.selectedFileReportDataBulkImport },
    getShowFileBulkImportDialog(state) { return state.showFileBulkImportDialog },
    getFileBulkUploaderFileRecordsForUpload(state) { return state.fileBulkUploaderFileRecordsForUpload },
    getFileBulkUploaderUploadUrl(state) { return state.fileBulkUploaderUploadUrl },
    getFileBulkUploaderUploadHeaders(state) { return state.fileBulkUploaderUploadHeaders },
    getFileBulkUploaderDeletable(state) { return state.fileBulkUploaderDeletable },
    getFileBulkUploaderReadonly(state) { return state.fileBulkUploaderReadonly },
    getFileBulkUploaderDetailsTag(state) { return state.fileBulkUploaderDetailsTag },
    getFileBulkUploaderDetailsSelectedLabelId(state) { return state.fileBulkUploaderDetailsSelectedLabelId },
    getFileBulkUploaderLabelsDropdown(state) { return state.fileBulkUploaderLabelsDropdown },

    //Drag&&Drop Importer
    getShowDragAndDropUploader(state) { return state.showDragAndDropUploader },
    getSelectedImageUploadFile(state) { return state.selectedImageUploadFile },
    getShowUploadBtnDragAndDropUploader(state) { return state.showUploadBtnDragAndDropUploader },
    getImageUploaderImageExists(state) { return state.imageUploaderImageExists },
    getImageUploaderContext(state) { return state.imageUploaderContext},

    //ImageUploadOnly
    getShowImageUploadOnlyDialog(state) { return state.showImageUploadOnlyDialog},
    //Drag&&Drop Media Uploader
    getSelectedMediaUploadFiles(state) { return state.selectedMediaUploadFiles },
    

    // getShowDialogText(state) { return state.showDialogText },
    getUploadProgressbarValue (state) { return state.uploadProgressbarValue },

    getAudio (state) { return state.audio },

    // Importers for Listpages
    getListpageImporters                                (state) { return state.listpageImporters },

    // Data sharing dialog
    getShowDataSharingDialog                            (state) { return state.showDataSharingDialog }
}